import { render, staticRenderFns } from "./FCard.vue?vue&type=template&id=d4f1e38c&"
import script from "./FCard.vue?vue&type=script&lang=js&"
export * from "./FCard.vue?vue&type=script&lang=js&"
import style0 from "./FCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports